<template>
  <div class="caresresident">
    <NavBar />
    <AuthBySessionExpired />
    <div class="container">
      <div class="row">
        <div
          class="
            col-xl-1 col-lg-2 col-md-2 col-sm-12 col-12
            pt-1
            d-flex
            align-items-center
          "
        >
          <v-btn class="btn-return" v-on:click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
          </v-btn>
        </div>
        <div
          class="
            col-xl-11 col-lg-10 col-md-10 col-sm-12 col-12
            d-flex
            justify-content-between
          "
        >
          <h1 class="title-pages">
            {{ resident.name }}
          </h1>
          <v-btn
            v-if="
              permission('write', 'resident_annotation') ||
              permission('write', 'resident_vital_signs')
            "
            class="btn-add"
            v-on:click="handleModalCreate"
          >
            <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
          </v-btn>
        </div>
      </div>
      <b-modal
        no-close-on-backdrop
        hide-footer
        id="popupTypeCreate"
        title="ADICIONAR CUIDADOS"
      >
        <div class="row">
          <div v-show="show == 'CUIDADOR_ENFERMAGEM'" class="col-md-12">
            <div class="d-flex justify-content-center align-itens-center">
              <VitalSigns
                v-if="permission('write', 'resident_vital_signs')"
                :rest_home_id="rest_home_id"
                :resident_id="resident_id"
                :user_id="user.id"
                :type="type"
                v-on:popup="handlePopup"
                v-on:created="getAllCaresResident"
              />
              <Annotation
                v-if="permission('write', 'resident_annotation')"
                :rest_home_id="rest_home_id"
                :resident_id="resident_id"
                :user_id="user.id"
                :type="type"
                v-on:popup="handlePopup"
                v-on:created="getAllCaresResident"
              />
            </div>
          </div>
        </div>
      </b-modal>
      <!-- /modal select type create -->
      <b-overlay :show="loadingResident" opacity="0.99">
        <div class="row">
          <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 col-12 d-flex">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              placeholder="Pesquisar"
              class="mr-1"
              dense
              outlined
            />
          </div>
          <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 d-flex">
            <v-text-field
              label="Filtrar por data inicial"
              type="date"
              v-model="dtInit"
              outlined
              dense
              @input="getAllCaresResident"
              class="mr-1"
            />
          </div>
          <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12 d-flex">
            <v-text-field
              label="Filtrar por data final"
              type="date"
              class="mr-1"
              v-model="dtEnd"
              outlined
              dense
              @input="getAllCaresResident"
            />
          </div>
        </div>
      </b-overlay>
      <b-overlay :show="loadingCares" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="cares.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="cares.length > 0"
          dense
          :headers="headers"
          :items="cares"
          :search="search"
          item-key="`${id}-${type}`"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          @click:row="handleClickRowTable"
        >
          <template v-slot:[`item.type`]="{ item }">{{
            handleType(item.type)
          }}</template>
          <template v-slot:[`item.annotation`]="{ item }">{{
            item.finish_by_check == 1 ? item.annotation : ""
          }}</template>
          <template v-slot:[`item.status`]="{ item }">
            <span
              v-if="item.typeItem == 'CARE'"
              :class="[
                'font-weight-bold',
                'text-success',
                item.status == 'A' && 'text-warning',
              ]"
            >
              {{ item.status == "A" ? "EM ABERTO" : "FINALIZADO" }}
            </span>
            <span
              v-if="item.typeItem == 'VITAL_SIGN'"
              :class="[
                'font-weight-bold',
                'text-success',
                item.pending_vital_signs > 0 && 'text-warning',
              ]"
            >
              {{ item.pending_vital_signs > 0 ? "EM ABERTO" : "FINALIZADO" }}
            </span>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at) }}</template
          >
          <template v-slot:[`item.typeItem`]="{ item }">
            {{ item.typeItem == "CARE" ? "ANOTAÇÃO" : "" }}
            {{ item.typeItem == "VITAL_SIGN" ? "SINAIS VITAIS" : "" }}
          </template>
          <template v-slot:[`item.pending_vital_signs`]="{ item }">
            <h6
              :class="[
                'mb-0 worksansr',
                'text-success',
                item.typeItem == 'CARE' && item.status == 'A' && 'text-warning',
                item.typeItem == 'VITAL_SIGN' &&
                  item.pending_vital_signs > 0 &&
                  'text-warning',
              ]"
            >
              {{
                item.typeItem == "CARE" && item.status == "A"
                  ? "EM ABERTO"
                  : item.typeItem == "CARE"
                  ? "FINALIZADO"
                  : item.typeItem == "VITAL_SIGN" &&
                    item.pending_vital_signs > 0
                  ? "EM ABERTO"
                  : "FINALIZADO"
              }}
            </h6>
          </template>
        </v-data-table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import VitalSigns from "../templates/Care/NursingCaregiver/Create/VitalSigns";

import Annotation from "../templates/Care/NursingCaregiver/Create/Annotation";

import api from "../services/api";

import moment from "moment";

import { formatDate } from "../lib/format";

import permission from "../lib/permission";

import routes from "../routes";

import { userData } from "../lib/functions";

export default {
  name: "CaresResident",
  components: {
    NavBar,
    VitalSigns,
    Annotation,
    AuthBySessionExpired,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "TIPO", sortable: false, value: "type" },
        { text: "", sortable: false, value: "annotation" },
        { text: "CRIADO POR", value: "user_name" },
        { text: "DATA CADASTRO", value: "created_at" },
        { text: "TIPO", value: "typeItem" },
        { text: "SITUAÇÃO", value: "pending_vital_signs" },
      ],
      rest_home_id: "",
      resident_id: "",
      type: "CUIDADOR_ENFERMAGEM",
      show: "CUIDADOR_ENFERMAGEM",
      resident: {},
      user: {},
      cares: [],
      loadingResident: true,
      loadingCares: true,
      dtInit: moment().subtract(7, "days").format("YYYY-MM-DD"),
      dtEnd: moment().format("YYYY-MM-DD"),
      loading: true,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    formatDate,
    permission,
    moment,
    handlePopup() {
      this.$bvModal.hide("popupTypeCreate");
    },
    handleClickRowTable({ id, typeItem }) {
      if (typeItem == "CARE") {
        routes.push({ name: "care", params: { id } });
      }

      if (typeItem == "VITAL_SIGN") {
        routes.push({ name: "vital_sign", params: { id } });
      }
    },
    handleChangeType({ target: { value } }) {
      this.show = value;
    },
    handleType(type) {
      var show = {
        CUIDADOR_ENFERMAGEM: "CUIDADOR/ENFERMAGEM",
        ENFERMEIRA: "ENFERMEIRA",
        MEDICO: "MÉDICO",
        EQUIPE_MULTIDISCIPLINAR: "EQUIPE MULTIDISCIPLINAR",
        default: "TIPO NÃO ENCONTRADO!",
      };

      return show[type] || show.default;
    },
    async retrieve() {
      const { user } = userData();

      this.rest_home_id = user.rest_home_id;

      this.user = user;

      const { resident_id } = routes.history.current.params;

      this.resident_id = resident_id;

      await this.getResident();
      await this.getAllCaresResident();
    },
    async getResident() {
      try {
        this.loadingResident = true;

        const { resident_id, rest_home_id } = this;

        const response = await api.get("/rest-home/resident/path", {
          params: { id: resident_id, rest_home_id },
        });

        const { resident, error } = response.data;

        if (error) {
          return routes.push({ name: "cares2" });
        }

        this.resident = resident;
        this.loadingResident = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getAllCaresResident() {
      try {
        this.loadingCares = true;

        const { resident_id, rest_home_id, dtInit, dtEnd } = this;

        const response = await api.get("/rest-home/care/resident/get", {
          params: {
            resident_id,
            rest_home_id,
            dtInit,
            dtEnd,
          },
        });

        const { cares, error } = response.data;

        if (error) {
          return routes.push({ name: "cares2" });
        }

        this.cares = cares;
        this.loadingCares = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.$bvModal.show("popupTypeCreate");
      this.type = "CUIDADOR_ENFERMAGEM";
      this.show = "CUIDADOR_ENFERMAGEM";
      this.errors = [];
    },
    handleToBack: () => routes.go(-1),
  },
};
</script>

<style>
.caresresident .text-filter {
  font-weight: 600;
  color: #555;
  text-align: center;
  margin-top: 15px;
}

.caresresident .back-color-filter {
  background-color: #f9f9f9;
}
</style>
